export default __webpack_public_path__ + "static/media/ascent.c03c5c82.jpeg";